import { render, staticRenderFns } from "./UsersGroupsPermissionsDialogToolsItem.vue?vue&type=template&id=1ecd4a70&scoped=true&"
import script from "./UsersGroupsPermissionsDialogToolsItem.vue?vue&type=script&lang=js&"
export * from "./UsersGroupsPermissionsDialogToolsItem.vue?vue&type=script&lang=js&"
import style0 from "./UsersGroupsPermissionsDialogToolsItem.vue?vue&type=style&index=0&id=1ecd4a70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecd4a70",
  null
  
)

export default component.exports